export class PropsUtil {
  constructor(private props: { [key: string]: any }) { }

  getProp(name: string): any {
    return this.props[name];
  }

  getObjectProp(obj: any, name: string): any {
    return obj?.[name];
  }
}
